function getUrl() {
  return window.appEnv.moamalatUrl || "https://npg.moamalat.net:6006/";
}
!(function () {
  function i() {
    var o = document.getElementById("LightboxBackdrop");
    null != o && null != o.parentNode && o.parentNode.removeChild(o);
  }
  function r(o, O, U) {
    var t,
      e,
      i,
      r,
      n,
      l,
      a,
      u,
      d,
      C,
      s,
      m,
      g,
      c,
      h,
      x,
      f,
      B,
      y,
      A,
      L,
      D,
      b,
      v,
      w,
      S,
      T,
      k,
      p,
      I,
      M,
      P,
      E,
      H,
      R,
      V,
      z,
      K,
      j,
      W,
      X,
      Y,
      F,
      q,
      G,
      J,
      Q,
      Z,
      $,
      N;
    return o
      ? ((o = null),
        (T = S = f = x = h = c = g = m = s = C = d = u = l = n = i = ""),
        (S = "37080b88-1063-44bf-8330-6e988b4f09ea"),
        (T = "f730a95a-cb56-4b1f-b65a-faa5bc1da96f"),
        ($ = Z = Q = J = G = q = Y = X = ""),
        void (F = B = F = r = e = t = 0) !== (a = window.Lightbox.Checkout.configure).paymentMethodFromLightBox &&
          (o = a.paymentMethodFromLightBox),
        (W = j = K = z = V = R = H = E = P = M = I = p = k = w = v = b = D = L = A = y = null) != a.OrderId &&
          (i = a.OrderId),
        null == a.MID || isNaN(a.MID) || (t = a.MID),
        null == a.TID || isNaN(a.TID) || (e = a.TID),
        null == a.AmountTrxn || isNaN(a.AmountTrxn) || (r = a.AmountTrxn / 1e3),
        null != a.MerchantReference && (n = a.MerchantReference),
        null != a.ReturnUrl && (l = a.ReturnUrl),
        void 0 !== a.SecureHash && (u = a.SecureHash),
        void 0 !== a.TrxDateTime && (d = a.TrxDateTime),
        void 0 !== a.ExpirationDateTime && (C = a.ExpirationDateTime),
        void 0 !== a.InvoiceNo && (X = a.InvoiceNo),
        void 0 !== a.InvoiceServicesStr && (Y = a.InvoiceServicesStr),
        null == a.FeeAmount || isNaN(a.FeeAmount) || (F = a.FeeAmount / 100),
        null != a.AdditionalCustomerData &&
          (void 0 !== a.AdditionalCustomerData.CustomerEmail &&
            null !== a.AdditionalCustomerData.CustomerEmail &&
            (s = a.AdditionalCustomerData.CustomerEmail),
          void 0 !== a.AdditionalCustomerData.CustomerMobile &&
            null !== a.AdditionalCustomerData.CustomerMobile &&
            (m = a.AdditionalCustomerData.CustomerMobile),
          void 0 !== a.AdditionalCustomerData.MessageCustomer &&
            null !== a.AdditionalCustomerData.MessageCustomer &&
            (g = a.AdditionalCustomerData.MessageCustomer),
          void 0 !== a.AdditionalCustomerData.MerchantCustomerId &&
            null !== a.AdditionalCustomerData.MerchantCustomerId &&
            (c = a.AdditionalCustomerData.MerchantCustomerId),
          void 0 !== a.AdditionalCustomerData.VoucherType &&
            null !== a.AdditionalCustomerData.VoucherType &&
            (h = a.AdditionalCustomerData.VoucherType),
          void 0 !== a.AdditionalCustomerData.CurrencyTwo &&
            null !== a.AdditionalCustomerData.CurrencyTwo &&
            (x = a.AdditionalCustomerData.CurrencyTwo),
          void 0 !== a.AdditionalCustomerData.CurrencyTwoValue &&
            null !== a.AdditionalCustomerData.CurrencyTwoValue &&
            (f = a.AdditionalCustomerData.CurrencyTwoValue),
          void 0 === a.AdditionalCustomerData.AdditionalFees ||
            null === a.AdditionalCustomerData.AdditionalFees ||
            isNaN(a.AdditionalCustomerData.AdditionalFees) ||
            (B = a.AdditionalCustomerData.AdditionalFees),
          void 0 !== a.AdditionalCustomerData.TokenCustomerId &&
            null !== a.AdditionalCustomerData.TokenCustomerId &&
            (S = a.AdditionalCustomerData.TokenCustomerId),
          void 0 !== a.AdditionalCustomerData.TokenCustomerSession &&
            null !== a.AdditionalCustomerData.TokenCustomerSession &&
            (T = a.AdditionalCustomerData.TokenCustomerSession),
          void 0 !== a.AdditionalCustomerData.ShowCustomerEmail &&
            null !== a.AdditionalCustomerData.ShowCustomerEmail &&
            (y = a.AdditionalCustomerData.ShowCustomerEmail),
          void 0 !== a.AdditionalCustomerData.ShowCustomerMobile &&
            null !== a.AdditionalCustomerData.ShowCustomerMobile &&
            (A = a.AdditionalCustomerData.ShowCustomerMobile),
          void 0 !== a.AdditionalCustomerData.ShowMessageCustomer &&
            null !== a.AdditionalCustomerData.ShowMessageCustomer &&
            (L = a.AdditionalCustomerData.ShowMessageCustomer),
          void 0 !== a.AdditionalCustomerData.ShowMerchantCustomerId &&
            null !== a.AdditionalCustomerData.ShowMerchantCustomerId &&
            (D = a.AdditionalCustomerData.ShowMerchantCustomerId),
          void 0 !== a.AdditionalCustomerData.ShowCurrencyTwo &&
            null !== a.AdditionalCustomerData.ShowCurrencyTwo &&
            (b = a.AdditionalCustomerData.ShowCurrencyTwo),
          void 0 !== a.AdditionalCustomerData.ShowAdditionalFees &&
            null !== a.AdditionalCustomerData.ShowAdditionalFees &&
            (v = a.AdditionalCustomerData.ShowAdditionalFees),
          void 0 !== a.AdditionalCustomerData.ConsumerEnterAmount) &&
          null !== a.AdditionalCustomerData.ConsumerEnterAmount &&
          (w = a.AdditionalCustomerData.ConsumerEnterAmount),
        null != a.LightBoxColorConfig &&
          (void 0 !== a.LightBoxColorConfig.TopBarColor &&
            null !== a.LightBoxColorConfig.TopBarColor &&
            (k = a.LightBoxColorConfig.TopBarColor),
          void 0 !== a.LightBoxColorConfig.ButtonPayColor &&
            null !== a.LightBoxColorConfig.ButtonPayColor &&
            (p = a.LightBoxColorConfig.ButtonPayColor),
          void 0 !== a.LightBoxColorConfig.BodyBackgroundColor &&
            null !== a.LightBoxColorConfig.BodyBackgroundColor &&
            (I = a.LightBoxColorConfig.BodyBackgroundColor),
          void 0 !== a.LightBoxColorConfig.Textcolor &&
            null !== a.LightBoxColorConfig.Textcolor &&
            (M = a.LightBoxColorConfig.Textcolor),
          void 0 !== a.LightBoxColorConfig.LinkTextColor &&
            null !== a.LightBoxColorConfig.LinkTextColor &&
            (P = a.LightBoxColorConfig.LinkTextColor),
          void 0 !== a.LightBoxColorConfig.ScrollbarColor &&
            null !== a.LightBoxColorConfig.ScrollbarColor &&
            (E = a.LightBoxColorConfig.ScrollbarColor),
          void 0 !== a.LightBoxColorConfig.ScrollbarBackgroundColor &&
            null !== a.LightBoxColorConfig.ScrollbarBackgroundColor &&
            (H = a.LightBoxColorConfig.ScrollbarBackgroundColor),
          void 0 !== a.LightBoxColorConfig.PaymentInfoBackgroundColor &&
            null !== a.LightBoxColorConfig.PaymentInfoBackgroundColor &&
            (R = a.LightBoxColorConfig.PaymentInfoBackgroundColor),
          void 0 !== a.LightBoxColorConfig.PaymentInfoLineColor &&
            null !== a.LightBoxColorConfig.PaymentInfoLineColor &&
            (V = a.LightBoxColorConfig.PaymentInfoLineColor),
          void 0 !== a.LightBoxColorConfig.HeaderOrFooterLineColor &&
            null !== a.LightBoxColorConfig.HeaderOrFooterLineColor &&
            (z = a.LightBoxColorConfig.HeaderOrFooterLineColor),
          void 0 !== a.LightBoxColorConfig.CloseButtonColor &&
            null !== a.LightBoxColorConfig.CloseButtonColor &&
            (K = a.LightBoxColorConfig.CloseButtonColor),
          void 0 !== a.LightBoxColorConfig.CloseButtonBackgroundColor &&
            null !== a.LightBoxColorConfig.CloseButtonBackgroundColor &&
            (j = a.LightBoxColorConfig.CloseButtonBackgroundColor),
          void 0 !== a.LightBoxColorConfig.LogoOne) &&
          null !== a.LightBoxColorConfig.LogoOne &&
          (W = a.LightBoxColorConfig.LogoOne),
        (N =
          (N =
            (N =
              (N =
                (N =
                  (N =
                    (N =
                      (N =
                        (N =
                          (N =
                            (N =
                              (N =
                                (N =
                                  (N =
                                    (N =
                                      (N =
                                        (N =
                                          (N =
                                            (N =
                                              (N =
                                                (N =
                                                  (N =
                                                    (N =
                                                      (N =
                                                        (N = "/?") +
                                                        "paymentMethodFromLightBox=" +
                                                        o +
                                                        "&OrderID=" +
                                                        i +
                                                        "&") +
                                                      "MID=" +
                                                      t +
                                                      "&MerchantReference=" +
                                                      n +
                                                      "&") +
                                                    "amount=" +
                                                    r +
                                                    "&TID=" +
                                                    e +
                                                    "&") +
                                                  "secureHashAnonymous=" +
                                                  u +
                                                  "&trxDateTime=" +
                                                  d +
                                                  "&") +
                                                "ExpirationDateTime=" +
                                                C +
                                                "&CustomerEmail=" +
                                                s +
                                                "&") +
                                              "CustomerMobile=" +
                                              m +
                                              "&MessageCustomer=" +
                                              g +
                                              "&") +
                                            "MerchantCustomerId=" +
                                            c +
                                            "&voucherType=" +
                                            h +
                                            "&") +
                                          "CurrencyTwo=" +
                                          x +
                                          "&CurrencyTwoValue=" +
                                          f +
                                          "&") +
                                        "AdditionalFees=" +
                                        B +
                                        "&TokenCustomerId=" +
                                        S +
                                        "&") +
                                      "TokenCustomerSession=" +
                                      T +
                                      "&ShowCustomerEmail=" +
                                      y +
                                      "&") +
                                    "ShowCustomerMobile=" +
                                    A +
                                    "&ShowMessageCustomer=" +
                                    L +
                                    "&") +
                                  "ShowMerchantCustomerId=" +
                                  D +
                                  "&ShowCurrencyTwo=" +
                                  b +
                                  "&") +
                                "ShowAdditionalFees=" +
                                v +
                                "&TopBarColor=" +
                                k +
                                "&") +
                              "ButtonPayColor=" +
                              p +
                              "&BodyBackgroundColor=" +
                              I +
                              "&") +
                            "Textcolor=" +
                            M +
                            "&LinkTextColor=" +
                            P +
                            "&") +
                          "ScrollbarColor=" +
                          E +
                          "&ScrollbarBackgroundColor=" +
                          H +
                          "&") +
                        "PaymentInfoBackgroundColor=" +
                        R +
                        "&PaymentInfoLineColor=" +
                        V +
                        "&") +
                      "HeaderOrFooterLineColor=" +
                      z +
                      "&CloseButtonColor=" +
                      K +
                      "&") +
                    "CloseButtonBackgroundColor=" +
                    j +
                    "&LogoOne=" +
                    W +
                    "&") +
                  "ConsumerEnterAmount=" +
                  w +
                  "&invoiceNo=" +
                  X +
                  "&") +
                "invoiceServicesStr=" +
                Y +
                "&feeAmount=" +
                F +
                "&") +
              "momoPaySubMerchantsDataStr=" +
              ($ = null != a.momoPaySubMerchantsDataStr ? a.momoPaySubMerchantsDataStr : $) +
              "&SKU=" +
              (q = null != a.SKU ? a.SKU : q) +
              "&") +
            "ProductName=" +
            (J = null != a.ProductName ? a.ProductName : J) +
            "&ProductType=" +
            (G = null != a.ProductType ? a.ProductType : G) +
            "&") +
          "CustomRegister=" +
          (Q = null != a.CustomRegister ? a.CustomRegister : Q) +
          "&MomoPayCommissionAmount=" +
          (Z = null != a.MomoPayCommissionAmount ? a.MomoPayCommissionAmount : Z) +
          "&"),
        O && ((N += "hideCloseButton=true&"), U) && (N += "returnUrl=" + l),
        getUrl() + "/Home/LightboxHostedCheckout" + N)
      : "";
  }
  ((window.Lightbox = window.Lightbox || {}),
    (Lightbox.Checkout = {
      showLightbox: function () {
        var o, t, e;
        this.configure
          ? ((o = r(this.configure, !1, !1)),
            ((t = document.createElement("div")).id = "LightboxBackdrop"),
            (t.style.position = "fixed"),
            (t.style.top = "0"),
            (t.style.left = "0"),
            (t.style.width = "100%"),
            (t.style.height = "100%"),
            (t.style.backgroundColor = "rgba(0, 0, 0, 0.5)"),
            (t.style.zIndex = "999998"),
            (t.style.display = "flex"),
            (t.style.alignItems = "center"),
            (t.style.justifyContent = "center"),
            (t.style.padding = "0px"),
            (t.style.boxSizing = "border-box"),
            ((e = document.createElement("iframe")).id = "Lightbox"),
            e.setAttribute("src", o),
            (e.style.zIndex = "999999"),
            (e.style.display = "block"),
            (e.style.backgroundColor = "white"),
            (e.style.border = "0px none transparent"),
            (e.style.borderRadius = "8px"),
            (e.style.boxShadow = "0 4px 20px rgba(0, 0, 0, 0.3)"),
            (e.style.overflowX = "hidden"),
            (e.style.overflowY = "auto"),
            (e.style.visibility = "visible"),
            (e.style.margin = "0"),
            (e.style.padding = "0"),
            (e.style.position = "relative"),
            (e.style.width = "100%"),
            (e.style.maxWidth = "572px"),
            (e.style.height = "100%"),
            (e.style.maxHeight = "890px"),
            t.appendChild(e),
            document.body.appendChild(t),
            window.addEventListener(
              "message",
              function (o) {
                var t = document.createElement("a"),
                  e = ((t.href = getUrl()), window.navigator.userAgent);
                (o.origin === t.origin ||
                  (null == t.origin &&
                    (0 < e.indexOf("MSIE ") || 0 < e.indexOf("Trident/") || 0 < e.indexOf("Edge/")))) &&
                  null != o.data &&
                  "" != o.data &&
                  ("errorCallback" == o.data.callback && void 0 !== this.Lightbox.Checkout.configure.errorCallback
                    ? this.Lightbox.Checkout.configure.errorCallback(o.data.Info)
                    : "completeCallback" == o.data.callback &&
                        void 0 !== this.Lightbox.Checkout.configure.completeCallback
                      ? this.Lightbox.Checkout.configure.completeCallback(o.data.paymentInfo)
                      : "cancelCallback" == o.data.callback &&
                        (i(), void 0 !== this.Lightbox.Checkout.configure.cancelCallback) &&
                        this.Lightbox.Checkout.configure.cancelCallback());
              },
              !1,
            ))
          : console.log("no configuration");
      },
      closeLightbox: i,
      configure: {},
      showPaymentPage: function () {
        this.configure ? (window.location = r(this.configure, !0, !0)) : console.log("no configuration");
      },
      getLightBoxUrl: function () {
        return this.configure ? r(this.configure, !0, !1) : "";
      },
    }));
})(window);
